module.exports = __webpack_public_path__ + "static/img/technology-1-SD-WAN-img-5.08a4c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology-1-SD-WAN-img-5.jpg
// module id = XFiS
// module chunks = 0